var map = {
	"./Carla Campos - Coordenadora Iº Ciclo.jpeg": 386,
	"./DSCF6255.jpg": 2206,
	"./DSCF6270.jpg": 1833,
	"./DSCF6273.jpg": 1566,
	"./DSCF6286.jpg": 9450,
	"./DSCF6305.jpg": 8968,
	"./DSCF6306.jpg": 9543,
	"./DSCF6319.jpg": 775,
	"./DSCF6320.jpg": 5095,
	"./DSCF6326.jpg": 2649,
	"./DSCF6329.jpg": 9938,
	"./DSCF6334.jpg": 4956,
	"./DSCF6345.jpg": 9068,
	"./DSCF6354.jpg": 7146,
	"./DSCF6365.jpg": 6482,
	"./DSCF6381.jpg": 1556,
	"./Elizabete Veloso - Coordenadora Ensino Primario.jpeg": 8425,
	"./Luisa Sousa-Coordenadora Infantario.jpeg": 9817,
	"./Mario Piedade - Director.jpeg": 3866,
	"./grad.jpg": 7268,
	"./kids-africa-2.jpg": 4557,
	"./kids-dancing-2.jpg": 4389,
	"./logo-nb.png": 232,
	"./logo-v2.png": 4976,
	"./logo.png": 5549,
	"./offer-ballet.jpeg": 1640,
	"./offer-capoeira.png": 729,
	"./offer-futsal.jpeg": 9153,
	"./offer-jujitsu.jpeg": 5908,
	"./offer-music.jpeg": 4211,
	"./offer-preregistration.jpg": 3647,
	"./our-space-10.jpg": 7775,
	"./our-space-11.jpg": 7778,
	"./our-space-2.jpg": 3392,
	"./our-space-4.jpg": 2086,
	"./our-space-5.jpg": 3699,
	"./our-space-6.jpg": 3652,
	"./our-space-7.jpg": 1697,
	"./our-space-8.jpg": 4346,
	"./our-space-9.jpg": 5511,
	"./principal.jpeg": 1541
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5162;